// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-nocheck
import Sterling from '../../../Texas/data/counties/Sterling.geo.json'
import Coke from '../../../Texas/data/counties/Coke.geo.json'
import Runnels from '../../../Texas/data/counties/Runnels.geo.json'
import Reagan from '../../../Texas/data/counties/Reagan.geo.json'
import Irion from '../../../Texas/data/counties/Irion.geo.json'
import Tom_Green from '../../../Texas/data/counties/Tom_Green.geo.json'
import Concho from '../../../Texas/data/counties/Concho.geo.json'
import McCulloch from '../../../Texas/data/counties/McCulloch.geo.json'
import Crockett from '../../../Texas/data/counties/Crockett.geo.json'
import Schleicher from '../../../Texas/data/counties/Schleicher.geo.json'
import Menard from '../../../Texas/data/counties/Menard.geo.json'
import Mason from '../../../Texas/data/counties/Mason.geo.json'
import Sutton from '../../../Texas/data/counties/Sutton.geo.json'
import Kimble from '../../../Texas/data/counties/Kimble.geo.json'

const counties = {
  Sterling,
  Coke,
  Runnels,
  Reagan,
  Irion,
  Tom_Green,
  Concho,
  McCulloch,
  Crockett,
  Schleicher,
  Menard,
  Mason,
  Sutton,
  Kimble
}

export default counties
